import { AppThunk } from 'store/types';
import {
  setPostVendorCommentsErrorAction,
  setPostVendorCommentsFetchStatusAction,
  setVendorCommentsAction,
  setVendorCommentsErrorAction,
  setVendorCommentsFetchStatusAction,
} from './reducer';
import { eVendorServiceType } from 'types/order/title/eVendorServiceType';
import { getCommentsAsync, postCommentAsync } from '../../../API/vendorDashboard/VendorAPI';
import { IVendorCommentData } from 'types/order/comment/IVendorComment';
import { createFetchedSuccess, createFetchedWithError, createFetchInProgress } from 'types/rest/IFetchStatus';
import { eAuthorType } from '../../../types/order/comment/eAuthorTypes';
import { eCommentType } from '../../../types/order/comment/eCommentType';

export const initVendorCommentsData =
  (orderId: string, types: eVendorServiceType[]): AppThunk =>
  async (dispatch, getState) => {
    const fetchStatus = getState().vendorDashboard.comments.getCommentsFetchStatus;
    if (!fetchStatus.fetching && !fetchStatus.fetched) {
      dispatch(getVendorCommentsData(orderId, types));
    }
  };

export const getVendorCommentsData =
  (orderId: string, types: eVendorServiceType[]): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setVendorCommentsErrorAction(undefined));
      dispatch(setVendorCommentsFetchStatusAction(createFetchInProgress()));
      const response: IVendorCommentData[] = await getCommentsAsync(orderId, types);
      const updatedResponse = response.map((com) =>
        com.author.type === eAuthorType.Vendor ? { ...com, authorName: 'Vendor User' } : com
      );
      dispatch(setVendorCommentsAction({ orderId, value: updatedResponse }));
      dispatch(setVendorCommentsFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setVendorCommentsAction({ orderId, value: [] }));
      dispatch(setVendorCommentsFetchStatusAction(createFetchedWithError()));
      dispatch(setVendorCommentsErrorAction(e.message));
    }
  };

export const uploadNewVendorComment =
  (orderId: string, commentContent: string, type: eCommentType): AppThunk =>
  async (dispatch, getState) => {
    const initialComments = getState().vendorDashboard.comments.comments[orderId];
    try {
      dispatch(setPostVendorCommentsErrorAction(undefined));
      dispatch(setPostVendorCommentsFetchStatusAction(createFetchInProgress()));
      const response: IVendorCommentData = await postCommentAsync(orderId, commentContent, type);
      response.author.fullName = response.author.type === eAuthorType.Vendor ? 'Vendor User' : response.author.fullName;
      dispatch(setVendorCommentsAction({ orderId, value: [response, ...initialComments] }));
      dispatch(setPostVendorCommentsFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setPostVendorCommentsFetchStatusAction(createFetchedWithError()));
      dispatch(setPostVendorCommentsErrorAction(e.message));
    }
  };
